var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8259 6.27772C20.5 7.28661 20.5 8.69108 20.5 11.5C20.5 14.3089 20.5 15.7134 19.8259 16.7223C19.534 17.159 19.159 17.534 18.7223 17.8259C17.8409 18.4148 16.6577 18.4892 14.5 18.4986V18.5L13.3944 20.7111C13.0259 21.4482 11.9741 21.4482 11.6056 20.7111L10.5 18.5V18.4986C8.3423 18.4892 7.15907 18.4148 6.27772 17.8259C5.84096 17.534 5.46596 17.159 5.17412 16.7223C4.5 15.7134 4.5 14.3089 4.5 11.5C4.5 8.69108 4.5 7.28661 5.17412 6.27772C5.46596 5.84096 5.84096 5.46596 6.27772 5.17412C7.28661 4.5 8.69108 4.5 11.5 4.5H13.5C16.3089 4.5 17.7134 4.5 18.7223 5.17412C19.159 5.46596 19.534 5.84096 19.8259 6.27772Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.5L15.5 9.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.5H12.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatroom);
export default __webpack_public_path__ + "static/media/chatroom.48240c2ec60d45f270626bc222f1b9ce.svg";
export { ForwardRef as ReactComponent };